import { useFlagsStatus, useVariant } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { ABTestingTrackingEvents, userTracking } from '@revelio/core';

import { getOrCreatePersistentUserId } from '../utils/getOrCreatePersistentUserId';
import Signup from './signup';
import SignupA from './signupA';

const ABSignup = () => {
  const { name: variantName } = useVariant('ab-signup-flow');
  const { flagsReady } = useFlagsStatus();
  const [searchParams] = useSearchParams();
  const [sessionId] = useLocalStorage<string>('unleash_user_id');
  const [lastTrackedSession, setLastTrackedSession] = useLocalStorage(
    'ab_test_last_tracked',
    ''
  );

  const [initializedSessionId, setInitializedSessionId] = useState<
    string | null
  >(null);

  const interest = searchParams.get('i');
  const referrer = searchParams.get('r');

  const isTestVariantA =
    variantName === 'apptSignup' && interest == null && referrer == null;

  useEffect(() => {
    if (!sessionId) {
      const persistentId = getOrCreatePersistentUserId();
      setInitializedSessionId(persistentId);
    } else {
      setInitializedSessionId(sessionId);
    }
  }, [sessionId]);

  const finalSessionId = sessionId || initializedSessionId;

  useEffect(() => {
    if (flagsReady && finalSessionId && finalSessionId !== lastTrackedSession) {
      if (isTestVariantA) {
        userTracking.track(ABTestingTrackingEvents.TEST_A_SESSION);
      } else {
        userTracking.track(ABTestingTrackingEvents.TEST_B_SESSION);
      }
      setLastTrackedSession(finalSessionId);
    }
  }, [
    isTestVariantA,
    flagsReady,
    finalSessionId,
    lastTrackedSession,
    setLastTrackedSession,
  ]);

  if (!flagsReady) {
    return null;
  }

  return isTestVariantA ? <SignupA /> : <Signup />;
};

export default ABSignup;
